exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .bbMxDK3UeVovU_poPobsA{padding:20px}._3B-ticRMyROr9QCfBknPNb{cursor:pointer;white-space:nowrap}html[dir] ._2pNeltItKjlnNU0zllytBT{padding-top:10px}", ""]);
// Exports
exports.locals = {
	"policyTipPeekContainer": "bbMxDK3UeVovU_poPobsA",
	"link": "_3B-ticRMyROr9QCfBknPNb",
	"policyTipButtonContainer": "_2pNeltItKjlnNU0zllytBT"
};